import { isNumber, isString } from "lodash";
import { FETE_FORMATS } from "./constant"

export const isNewFete = () => {
    const currentPath = window.location.pathname;
    const isNewFete = currentPath.includes('fete/new');
    return isNewFete;
}

const rangePercentage = 1.0;

export const getRangeValuesFromString = (val:any) => {
    if(isString(val)){
        if(val.includes('-')){
            const parts = val.split('-')
            return {
                min: parts[0] && parseInt(parts[0]) ? parseInt(parts[0]) : null,
                max: parts[1] && parseInt(parts[1]) ? parseInt(parts[1]) : null,
            }
        }
    }
}

export const getFeteFormatByNumber = (formatId:any) => {
    const feteFormat = FETE_FORMATS.find((feteFormat: any) => feteFormat.id === formatId)
    return feteFormat?.label
}

export const getFeteFormatByValue = (format:any) => {
    const feteFormat = FETE_FORMATS.find((feteFormat: any) => feteFormat.label === format)
    return feteFormat?.id
}

export const getMinValueForRange = (currentVal: any) => {
    const newMinValue = parseInt(currentVal);
    const dynamicMinValue = newMinValue - Math.round(rangePercentage * newMinValue);
    return dynamicMinValue < 0 ? 0 : dynamicMinValue
}

export const getMaxValueForRange = (currentVal: any) => {
    const newMaxValue = parseInt(currentVal);
    const dynamicMaxValue = currentVal + Math.round(rangePercentage * newMaxValue);
    return dynamicMaxValue < 0 ? 0 : dynamicMaxValue;
}

export const getRangeStep = (min: any, max: any) => {
    const rangeStep = Math.round(min+max/10);
    return rangeStep < 0 ? 0 : rangeStep;
}

export const getUpcomingDate = (amount: number, unit: string) => {
    const currentDate = new Date();
    let newDate;

    switch (unit.toLowerCase()) {
        case 'hours':
        case 'hour':
        case 'h':
            newDate = new Date(currentDate.getTime() + amount * 3600000); // 1 hour = 3600000 milliseconds
            break;

        case 'days':
        case 'day':
        case 'd':
            newDate = new Date(currentDate.getTime() + amount * 86400000); // 1 day = 86400000 milliseconds
            break;

        case 'months':
        case 'month':
        case 'm':
            newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + amount, currentDate.getDate());
            break;

        default:
            throw new Error('Invalid unit. Use "hours", "days", or "months".');
    }

    return newDate;
}

export const getPastDate = (amount: number, unit: string) => {
    const currentDate = new Date();
    let newDate;

    switch (unit.toLowerCase()) {
        case 'hours':
        case 'hour':
        case 'h':
            newDate = new Date(currentDate.getTime() - amount * 3600000); // 1 hour = 3600000 milliseconds
            break;

        case 'days':
        case 'day':
        case 'd':
            newDate = new Date(currentDate.getTime() - amount * 86400000); // 1 day = 86400000 milliseconds
            break;

        case 'months':
        case 'month':
        case 'm':
            newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - amount, currentDate.getDate());
            break;

        default:
            throw new Error('Invalid unit. Use "hours", "days", or "months".');
    }

    return newDate;
};
